const CkycCard = (props) => {
    const { ckycData, handleGenerateCKYC, isCkycGenerated, hideGenerateButton, showRegenerateButton, handleRegenerateCKYC, isAdmin } = props;
    console.log({ ckycData });

    return (

        <div className="ckyc-success-card p-4">
            <div className="d-flex align-items-start mb-3">
                <i className="fa fa-check-circle fs-4 me-2 mt-2"></i>
                <div>
                    <h5 className="mb-0">CKYC Record Found</h5>
                    <p className="mb-0">Matching CKYC record found for the identifier provided.</p>
                </div>
            </div>

            <div className="ckyc-details-box p-4 mt-3">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">Name</span>
                            <span className="field-value w-50">: {ckycData?.name || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">CKYC ID</span>
                            <span className="field-value w-50">: {ckycData?.ckyc_id || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">Father's Name</span>
                            <span className="field-value w-50">: {ckycData?.father_name || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">CKYC Reference ID</span>
                            <span className="field-value w-50">: {ckycData?.ckyc_ref_id || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">Age</span>
                            <span className="field-value w-50">: {ckycData?.age || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">KYC Date</span>
                            <span className="field-value w-50">: {ckycData?.kyc_date || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">Mobile Number</span>
                            <span className="field-value w-50">: {`${ckycData?.mobile_code || ''} ${ckycData?.mob_num || ''}`.trim() || "-"}</span>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="d-flex">
                            <span className="field-label w-50">Remarks</span>
                            <span className="field-value w-50">: {ckycData?.remarks || "-"}</span>
                        </div>
                    </div>
                </div>
                {!hideGenerateButton && (
                    <div className="text-end mt-3">
                        <button
                            type="button"
                            className="btn btn-primary px-4 py-2"
                            onClick={handleGenerateCKYC}
                            disabled={isCkycGenerated}
                        >
                            Generate CKYC
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default constore(CkycCard);